export default __webpack_public_path__ + "static/media/ss.9731b1dd.svg";